// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// global components
import NotFound from 'shared/components/NotFound';
import SomethingWentWrong from 'shared/components/SomethingWentWrong';
import DelayedRenderer from 'shared/components/DelayedRenderer';
import DelayedRenderProvider from 'shared/components/DelayedRenderer/DelayedRenderProvider';

// components
import Placeholder from 'shared/layouts/DetailsPage/components/Placeholder';
import ExploreApi from 'shared/layouts/DetailsPage/components/ExploreApi';

interface IDetailErrorWrapperProps {
  isFetching: boolean;
  isFetchingError: boolean;
  isNotFound: boolean;
  productID: string;
  children: React.ReactNode;
  statusCode: string;
}

function DetailErrorWrapper({
  isFetching,
  isFetchingError,
  isNotFound,
  productID,
  children,
  statusCode,
}: IDetailErrorWrapperProps) {
  if (isNotFound) {
    return <NotFound />;
  }

  if (isFetchingError) {
    return <SomethingWentWrong statusCode={statusCode} />;
  }

  // no fetching error and current trying to fetch or empty product id
  if (isFetching || isEmpty(productID)) {
    return <Placeholder />;
  }

  return (
    <DelayedRenderProvider>
      {children}
      <DelayedRenderer>
        <ExploreApi productID={productID} />
      </DelayedRenderer>
    </DelayedRenderProvider>
  );
}

export default memo(DetailErrorWrapper);
